import { render, staticRenderFns } from "./InForm2.vue?vue&type=template&id=eb17ed0e&scoped=true&"
import script from "./InForm2.vue?vue&type=script&lang=js&"
export * from "./InForm2.vue?vue&type=script&lang=js&"
import style0 from "./InForm2.vue?vue&type=style&index=0&id=eb17ed0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb17ed0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VRow,VSimpleTable})
